import { TAG_FQN_PREFIXES } from '@/shared/lib/constants';

import type { TagOption } from '@/entities/tags';

import { getTagCategoriesApi, getTagsApi } from '@/features/tags/api';

export const fetchAvailableTags = async (): Promise<TagOption[]> => {
  try {
    const categoriesResponse = await getTagCategoriesApi({ limit: 1000 });
    const categories = categoriesResponse.data;

    const allTagsPromises = categories.map(async (category) => {
      const categoryName = category.name;

      if (categoryName === 'Tier' || categoryName === 'Certification') {
        return [];
      }

      try {
        const tagsResponse = await getTagsApi({
          parent: categoryName,
          limit: 1000,
          fields: 'usageCount',
        });
        return tagsResponse.data
          .filter((tag) => !tag.disabled)
          .filter((tag) => {
            const fqn = tag.fullyQualifiedName;
            return !fqn.startsWith(TAG_FQN_PREFIXES.TIER) && !fqn.startsWith(TAG_FQN_PREFIXES.CERTIFICATION);
          })
          .map((tag): TagOption => {
            return {
              value: tag.fullyQualifiedName,
              name: tag.name,
              label: tag.displayName || tag.name,
              description: tag.description || '',
              classification: category.displayName || categoryName,
              mutuallyExclusive: category.mutuallyExclusive,
              classificationFQN: categoryName,
            };
          });
      } catch (error) {
        console.warn(`Failed to fetch tags for category ${categoryName}:`, error);
        return [];
      }
    });

    const allTagsArrays = await Promise.all(allTagsPromises);
    return allTagsArrays.flat();
  } catch (error) {
    console.error('Failed to fetch available tags:', error);
    throw error;
  }
};
